import type { IBimRelationshipEdge, IBimRelationshipNode } from '@skystone/shared';
import { Badge } from '@/components/ui';
import { cardinalityLabel } from '@/lib/bim-relationship-utils';

export interface BimSelectionPanelsProps {
  selectedEdge: IBimRelationshipEdge | null;
  selectedNode: IBimRelationshipNode | null;
}

export function BimSelectionPanels({ selectedEdge, selectedNode }: BimSelectionPanelsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div className="rounded-md border border-border bg-card p-4">
        <h3 className="text-sm font-semibold">Selected Relationship</h3>
        {!selectedEdge && (
          <p className="mt-2 text-sm text-muted-foreground">Click an edge in the graph or a row in the list.</p>
        )}
        {selectedEdge && (
          <div className="mt-2 space-y-1 text-sm">
            <p><span className="font-medium">From:</span> {selectedEdge.fromTable}.{selectedEdge.fromColumn}</p>
            <p><span className="font-medium">To:</span> {selectedEdge.toTable}.{selectedEdge.toColumn}</p>
            <p><span className="font-medium">Cardinality:</span> {cardinalityLabel(selectedEdge)} ({selectedEdge.cardinality})</p>
            <p><span className="font-medium">Cross filter:</span> {selectedEdge.crossFilteringBehavior ?? 'n/a'}</p>
            <p><span className="font-medium">Active:</span> {selectedEdge.isActive ? 'true' : 'false'}</p>
          </div>
        )}
      </div>

      <div className="rounded-md border border-border bg-card p-4">
        <h3 className="text-sm font-semibold">Selected Table Keys</h3>
        {!selectedNode && (
          <p className="mt-2 text-sm text-muted-foreground">Click a table card to inspect its key fields.</p>
        )}
        {selectedNode && (
          <div className="mt-2 space-y-2 text-sm">
            <p><span className="font-medium">Table:</span> {selectedNode.tableName}</p>
            <p><span className="font-medium">Role:</span> {selectedNode.role}</p>
            <div className="flex flex-wrap gap-2">
              {selectedNode.keyColumns.map((column) => (
                <Badge key={column} variant="secondary">{column}</Badge>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
